/* eslint-disable react/function-component-definition */
/* eslint-disable valid-typeof */
import * as Value from './Value.js'
import * as ArrayValue from './ArrayValue.js'
import * as MapValue from './MapValue.js'
import * as Util from './Util.js'

function createValidator( { type, allowNullish = true } ) {
  return ( m, k, v ) => {
    if ( allowNullish && v == null ) {
      return null
    }
    if ( typeof v !== type ) {
      throw Error( `${k} should be set to a value of type ${type}. It is a ${typeof v}: ${v}` )
    }
    return undefined
  }
}

function createArrayValidator( { type, allowNullish = true, allowNullEntries = false } ) {
  return ( m, k, v ) => {
    if ( allowNullish && v == null ) {
      return null
    }
    if ( !Array.isArray( v ) ) {
      throw Error( `${k} should be set to an Array. It is a ${typeof v}: ${v}` )
    }
    if ( type ) {
      if ( v.some( item => typeof item !== type ) ) {
        throw Error( `${k} should be set to an Array of ${type}. It is: ${v}` )
      }
    }
    return undefined
  }
}

const isString = createValidator( { type : 'string' } )
const isNumber = createValidator( { type : 'number' } )
const isNumberArray = createArrayValidator( { type : 'number' } )
const isStringArray = createArrayValidator( { type : 'string' } )

const isStringTrimAndNull = ( m, k, v ) => {
  if ( v == null ) {
    return null
  }
  if ( typeof v !== 'string' ) {
    throw Error( `${k} should be set to a string. It was given is a ${typeof v}: ${v}` )
  }
  const t = v.trim()
  if ( t.length === 0 ) {
    return null
  }
  return t
}

export default {
  ...Value, 
  ...ArrayValue,
  ...MapValue,
  ...Util,

  isStringTrimAndNull,
  isNumber,
  isString,
  isStringArray,
  isNumberArray,

  createValidator,
  createArrayValidator
}
